
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","fill":"none","viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#F9B621","stroke":"#363636"}},[_c('circle',{attrs:{"cx":"9.55","cy":"17.5","r":"3.45"}}),_c('circle',{attrs:{"cx":"34.4","cy":"17.5","r":"3.45"}}),_c('circle',{attrs:{"cx":"22.1","cy":"12.7","r":"5.35","fill":"#24A4EC"}})]),_c('g',{attrs:{"fill":"#fff","stroke":"#494949","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M7 25.31a3.75 3.75 0 00-3.75 3.75v2.88A2.75 2.75 0 006 34.69h6c.97 0 1.75-.79 1.75-1.75v-3.88A3.75 3.75 0 0010 25.31H7zm27 0a3.75 3.75 0 00-3.75 3.75v3.88c0 .96.78 1.75 1.75 1.75h6a2.75 2.75 0 002.75-2.75v-2.88A3.75 3.75 0 0037 25.31h-3z"}}),_c('path',{attrs:{"d":"M13 28.69a6 6 0 016-6h6a6 6 0 016 6v4.62a4 4 0 01-4 4H17a4 4 0 01-4-4V28.7z"}})])])
          )
        }
      }
    